module.exports = __webpack_public_path__ + "static/media/xray-training-kneecap-view2.6742b675.png";